import React from "react";
import { useParams } from "react-router-dom";
// Style
import "./QRPage.scss";

// Components
import PageHero from "../../containers/PageHero/PageHero";

// QRs
import QR_heb from "../../styles/img/assets/QR_heb.svg"; // Hebrew QR code
import QR_eng from "../../styles/img/assets/QR_eng.svg"; // English QR code

function QRPage() {
  const { lang } = useParams();

  const QRsvg: Record<string, string> = {
    eng: QR_eng, // Default to English CV
    heb: QR_heb, // Hebrew CV
  };

  const selectedPDF = QRsvg[lang || "CV"] || QR_eng;

  return (
    <section className="QR_section">
      <PageHero>
        <h1 className="QR_h1">Here's your QR</h1>
      </PageHero>

      <div className="flexCenter QR_container">
        <img id="QR_CV" src={selectedPDF} alt="CV QR code" />
        <h3>
          Scan to download <span>Alon Fabio</span>'s CV
        </h3>
      </div>
    </section>
  );
}

export default QRPage;
